<div class="d-flex justify-content-center align-items-center py-4">
    <iframe [srcdoc]="data" style="height: 100vh;" frameborder="0"></iframe>
</div>